<template>
  <section :class="['trusted_by_section', sectionClass]" v-if="brand_list.length">
            <div class="container">
                <div class="trusted_by_box">
                <div class="section_heading_box">
                    <h2 class="trusted_by_title section_heading "><span class="bg_secondary_white px_40">Trusted By</span></h2>

                </div>
                    
                    <div class="owl-carousel trusted_by_slider" v-if="brand_list.length">
                        <div
                            class="item trusted_by_slide_item"
                            v-for="(brandGroup, groupIndex) in brand_list"
                            :key="'trusted-by-group-' + groupIndex"
                        >
                            <div class="trusted_by_logo_strip">
                                <div
                                    class="trusted_by_logo_item"
                                    v-for="(brand, index) in brandGroup"
                                    :key="'trusted-by-brand-' + (brand.id || index)"
                                >
                                    <img
                                        :src="brand.logo_image"
                                        :alt="brand.name ? brand.name : 'brand_logo'"
                                        class="trusted_by_logo_img"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="trusted_by_dots_custom" v-if="brand_list.length">
                        <span
                            v-for="dot in trustedByWindowDots"
                            :key="'trusted-by-window-dot-' + dot.role"
                            class="trusted_by_dot"
                            :class="{
                                'trusted_by_dot--active': dot.active,
                                'trusted_by_dot--disabled': dot.disabled
                            }"
                            @click="onTrustedByWindowDotClick(dot)"
                        ></span>
                    </div>
                    <div class="trusted_by_logo_strip trusted_by_logo_strip--placeholder" v-else>
                        <div class="trusted_by_logo_item" v-for="n in 6" :key="'trusted-by-placeholder-' + n"></div>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
export default {
    name: "TrustedBySection",
    props: {
        logos: {
            type: Array,
            default: () => []
        },
        sectionClass: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            trustedByActiveIndex: 0,
            trustedByTotalSlides: 0
        };
    },
    computed: {
        brand_list() {
            const normalizedLogos = (this.logos || []).filter((x) => x && x.logo_image);
            const chunkSize = 6;
            const chunks = [];
            for (let i = 0; i < normalizedLogos.length; i += chunkSize) {
                chunks.push(normalizedLogos.slice(i, i + chunkSize));
            }
            return chunks;
        },
        trustedByWindowDots() {
            const total = this.trustedByTotalSlides || this.brand_list.length || 0;
            const current = Math.max(
                0,
                Math.min(this.trustedByActiveIndex, Math.max(total - 1, 0))
            );
            if (!total) return [];
            const prevIndex = current > 0 ? current - 1 : total - 1;
            const nextIndex = current < total - 1 ? current + 1 : 0;
            return [
                {
                    role: "prev",
                    targetIndex: prevIndex,
                    active: false,
                    disabled: total <= 1
                },
                {
                    role: "current",
                    targetIndex: current,
                    active: true,
                    disabled: true
                },
                {
                    role: "next",
                    targetIndex: nextIndex,
                    active: false,
                    disabled: total <= 1
                }
            ];
        }
    },
    watch: {
        brand_list() {
            this.$nextTick(() => {
                this.initTrustedBySlider();
            });
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initTrustedBySlider();
        });
    },
    beforeDestroy() {
        if (typeof $ !== "undefined") {
            const $trustedBySlider = $(this.$el).find(".trusted_by_slider");
            if ($trustedBySlider.length > 0) {
                $trustedBySlider.trigger("destroy.owl.carousel");
                $trustedBySlider.off("initialized.owl.carousel changed.owl.carousel");
            }
        }
    },
    methods: {
        onTrustedByWindowDotClick(dot) {
            if (!dot || dot.disabled || dot.targetIndex == null) return;
            if (typeof $ !== "undefined") {
                const $trustedBySlider = $(this.$el).find(".trusted_by_slider");
                if ($trustedBySlider.length > 0) {
                    $trustedBySlider.trigger("to.owl.carousel", [dot.targetIndex, 250]);
                }
            }
        },
        initTrustedBySlider() {
            if (typeof $ === "undefined" || !$.fn || !$.fn.owlCarousel) return;
            const _this = this;
            const $trustedBySlider = $(this.$el).find(".trusted_by_slider");
            if ($trustedBySlider.length === 0) return;

            if ($trustedBySlider.data("owl.carousel")) {
                $trustedBySlider.trigger("destroy.owl.carousel");
                $trustedBySlider.off("initialized.owl.carousel changed.owl.carousel");
            }

            $trustedBySlider.on(
                "initialized.owl.carousel changed.owl.carousel",
                function (event) {
                    const pageInfo = event && event.page ? event.page : null;
                    _this.trustedByActiveIndex = pageInfo ? pageInfo.index : 0;
                    _this.trustedByTotalSlides = pageInfo
                        ? pageInfo.count
                        : _this.brand_list.length;
                }
            );

            $trustedBySlider.owlCarousel({
                loop: true,
                margin: 0,
                nav: false,
                dots: true,
                items: 1,
                slideBy: 1,
                autoplay: true,
                autoplayTimeout: 7000,
                autoplayHoverPause: false
            });
        }
    }
};
</script>
